import * as types from "./constants";

import update from 'immutability-helper';

const initialState = {
  // TODO - Differentiate between max/exceeds/at stage files and selected files
  maxFiles: 50,
  percentComplete: 0,
  isUploading: false,
  exceedsFileLimit: false,
  atFileLimit: false,
  stagedFiles: {
    files: [],
    count: 0
  },
  selectedFiles: {
    files: [],
    count: 0
  }
};

function fileUploaderReducer(state = initialState, action) {
  switch(action.type) {
    case types.SET_UPLOAD_PROGRESS:
      return update(state, { percentComplete: { $set: action.percentComplete } });
    case types.SET_IS_UPLOADING:
      return update(state, { isUploading: { $set: action.isUploading } });
    case types.ADD_STAGED_FILE:
      return invalidateFileLimit(addFileToArrayByName('stagedFiles', state, action));
    case types.REMOVE_STAGED_FILE:
      return invalidateFileLimit(removeFileFromArrayByName('stagedFiles', state, action));
    case types.ADD_SELECTED_FILE:
      return addFileToArrayByName('selectedFiles', state, action);
    case types.REMOVE_SELECTED_FILE:
      return removeFileFromArrayByName('selectedFiles', state, action);
    case types.RESET_FILE_UPLOADER:
      return initialState;
    default:
      return state;
  }
}

function invalidateFileLimit(state) {
  const { stagedFiles } = state;
  const exceedsFileLimit = stagedFiles.count > state.maxFiles;
  const atFileLimit = stagedFiles.count === state.maxFiles;

  return update(state, {
    exceedsFileLimit: { $set: exceedsFileLimit },
    atFileLimit: { $set: atFileLimit }
  });
}

function addFileToArrayByName(name, state, action) {
  let files = state[name].files;
  const newFileList = files.slice(0);
  const index = files.indexOf('') !== -1? files.indexOf(''): newFileList.length;
  newFileList.splice(index, 0, action.file);

  return update(state, {
    [name]: {
      files: { $set: newFileList },
      count: { $set: newFileList.length }
    }
  });
}

function removeFileFromArrayByName(name, state, action) {
  const files = state[name].files;
  const index = files.lastIndexOf(action.file);
  if (index !== -1) {
    const newFileList = files.slice(0);
    newFileList.splice(index, 1);
    return update(state, {
      [name]: {
        files: { $set: newFileList },
        count: { $set: newFileList.length }
      }
    });
  }
  return state;
}

export default fileUploaderReducer;



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/file-uploader/reducers.es6